import { render, staticRenderFns } from "./DrawerSevenClubPrefixTest.vue?vue&type=template&id=9152b232&scoped=true&"
import script from "./DrawerSevenClubPrefixTest.vue?vue&type=script&lang=js&"
export * from "./DrawerSevenClubPrefixTest.vue?vue&type=script&lang=js&"
import style0 from "./DrawerSevenClubPrefixTest.vue?vue&type=style&index=0&id=9152b232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9152b232",
  null
  
)

export default component.exports